// src/pages/AiAstrologerPage.jsx
import React from "react";
import HeygenVideoGenerator from "../components/HeygenVideoGenerator";

export default function AiAstrologerPage() {
  return (
    <section>
      <div className="about_banner_section banner_space cd_section">
        <div className="container">
          <div className="row m-0">
            <div className="col-lg-12">
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-6">
      <HeygenVideoGenerator />
    </div>
    </div>
    </div>
    </div>
    </div>
    </section>
  );
}
